import { VisSingleContainer, VisTopoJSONMap } from '@unovis/react'
import { WorldMapTopoJSON } from '@unovis/ts/maps'
import { MapData } from '@unovis/ts'
import { useState } from 'react';

type MapAreaProps = {
  data: MapData<{ id: string; }>;
};

const GeoMaps: React.FC<MapAreaProps> = ({ data }) => {
  const [hoveredCountry, setHoveredCountry] = useState<{ name: string; x: number; y: number } | null>(null);

  return (
    <div style={{ position: 'relative' }}>
      <VisSingleContainer data={data}>
        <VisTopoJSONMap
          topojson={WorldMapTopoJSON}
          areaColor={(d: any) => (d.id === hoveredCountry?.name ? '#FF9900' : '#794FF2')}
        />
      </VisSingleContainer>
    </div>
  );
};

export default GeoMaps;
